import AlertTriangleFill from '@geist-ui/icons/alertTriangleFill';
import ChevronsUp from '@geist-ui/icons/chevronsUp';
import ChevronDown from '@geist-ui/icons/chevronDown';

export const issuesPrior = [
  {
    title: 'issuesBySeverity.Critical',
    field: 'critical',
    filter: 'severity',
    icon:<AlertTriangleFill role="presentation" color="#A80000" stroke="#FFFFFF" />,
  },
  {
    title: 'issuesBySeverity.High',
    field: 'high',
    filter: 'severity',
    icon: <ChevronsUp role="presentation" color="#C91717" />,
  },
  {
    title: 'issuesBySeverity.Medium',
    field: 'medium',
    filter: 'severity',
    icon: <ChevronsUp role="presentation" color="#D88803" />,
  },
  {
    title: 'issuesBySeverity.Low',
    field: 'low',
    filter: 'severity',
    icon: <ChevronDown role="presentation" color="#3CA661" />,
  },
  {
    title: 'issuesBySeverity.Warning',
    field: 'warning',
    filter: 'severity',
    icon: <AlertTriangleFill role="presentation" color="#D88803" stroke="#FFFFFF" />,
  },
];
